// src/pages/TermsPage.js
import React from 'react';

function TermsPage() {
  return (
    <div className="pricing-page" style={{textAlign:'left'}}>
      <h2>Terms of Service</h2>
      <p>By using Compliance Guardian, you agree to these terms.</p>
      <ul>
        <li>Service is provided on a subscription basis.</li>
        <li>You are responsible for appropriate access controls in your tenant.</li>
        <li>Liability is limited to the extent permitted by law.</li>
      </ul>
      <p>Questions? Email <a href="mailto:support@complianceguardian.cloud">support@complianceguardian.cloud</a>.</p>
    </div>
  );
}

export default TermsPage;
